import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/employees', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/employees/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/employees', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/employees/${data.staff_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const uploadPhoto = data => {
  return httpClient
    .post('/api/employees/upload-photos', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/employees/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const employeePosition = (Options = {}) => {
  return httpClient
    .get('/api/employees/positions', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getDivision = (Options = {}) => {
  return httpClient
    .get('/api/employees/divisions', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getDepartment = (division_id, Options = {}) => {
  return httpClient
    .get(`/api/employees/${division_id}/departments`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getShift = (Option = {}) => {
  return httpClient
    .get(
      '/api/attendance-shifts?page=-1&fields[attendance_shifts]=shift_id,shift_name,shift_type',
      Option
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const employeeStatus = (Options = {}) => {
  return httpClient
    .get('/api/employees/statuses', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const employeeProvince = (Options = {}) => {
  return httpClient
    .get('/api/employees/provinces', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getEmployeeId = (hired_date, Options = {}) => {
  return httpClient
    .get(`/api/employees/${hired_date}/employee-id`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getDistrict = (province_code, Options = {}) => {
  return httpClient
    .get(`/api/employees/${province_code}/districts`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getCommune = (district_code, Options = {}) => {
  return httpClient
    .get(`/api/employees/${district_code}/communes`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getVillage = (commune_code, Options = {}) => {
  return httpClient
    .get(`/api/employees/${commune_code}/villages`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const employeeIdType = (Options = {}) => {
  return httpClient
    .get('/api/employees/id-types', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const employeeSpouseOccupation = (Options = {}) => {
  return httpClient
    .get('/api/employees/spouse-occupations', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getEmployee = (options = {}) => {
  return httpClient
    .get(
      '/api/employees?fields[setup_staff_information]=staff_id,name_kh,name_en&page=-1',
      options
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const printCard = (Options = {}) => {
  return httpClient
    .get('/api/employees/preview-cards', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const exportExcel = data => {
  return httpClient
    .post('/api/employees/export-excel', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const branch = (Options = {}) => {
  return httpClient
    .get('/api/employees/branches', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const transferBranch = data => {
  return httpClient
    .post('/api/employees/transfers', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const employeeName = (Options = {}) => {
  return httpClient
    .get('/api/employees/employeeNames', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const increasePrinterCardCounter = staffId => {
  return httpClient
    .get(`/api/employees/increase/${staffId}/print-card-counters`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const staffType = (Options = {}) => {
  return httpClient
    .get('/api/employees/staff-types', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const notionality = (Options = {}) => {
  return httpClient
    .get('/api/employees/nationalities', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const createReason = data => {
  return httpClient
    .post('/api/employees/add-status-reason', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const statusReason = (Options = {}) => {
  return httpClient
    .get('/api/employees/status-reason', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  uploadPhoto,
  employeePosition,
  employeeStatus,
  employeeProvince,
  getEmployeeId,
  getDistrict,
  getCommune,
  getVillage,
  employeeIdType,
  employeeSpouseOccupation,
  getDivision,
  getDepartment,
  getEmployee,
  getShift,
  printCard,
  exportExcel,
  branch,
  transferBranch,
  employeeName,
  increasePrinterCardCounter,
  staffType,
  notionality,
  createReason,
  statusReason
}
